/** Scroll so `element` aligns to the top of `container` without moving ancestor/page scroll. */
export function scrollElementToStartWithinContainer(
    element: Element,
    container: HTMLElement,
    behavior: ScrollBehavior = 'smooth',
): void {
    const containerRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const targetScrollTop = container.scrollTop + (elementRect.top - containerRect.top);
    container.scrollTo({ top: Math.max(0, targetScrollTop), behavior });
}
